import { Link } from "react-router-dom";
import { useMemo } from "react";
import { ANIMATION_PROJECTS } from "../data/portfolio";

export default function AnimationIndex() {
  const projects = useMemo(
    () => ANIMATION_PROJECTS.map(p => ({
      ...p,
      cover: p.cover || p.items[Math.floor(Math.random() * p.items.length)].src,
    })),
    []
  );
  return (
    <section className="max-w-[1600px] mx-auto px-6 lg:px-10 py-16 md:py-24" data-testid="animation-index">
      <div className="mb-14 md:mb-20 flex items-end justify-between gap-8 reveal">
        <div>
          <div className="text-xs uppercase tracking-[0.35em] text-[var(--ember)] mb-4">Selected Projects</div>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.85] text-[var(--paper)] italic">Animation</h1>
          <p className="mt-6 max-w-xl text-[var(--bone)] text-base md:text-lg leading-relaxed">
            Visual development, color keys, background painting and layout for feature animation —
            organized by project.
          </p>
        </div>
        <div className="hidden md:block text-right text-xs uppercase tracking-[0.3em] text-[var(--muted)]">
          {projects.length} projects
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
        {projects.map((p, idx) => (
          <Link
            key={p.slug}
            to={`/animation/${p.slug}`}
            data-testid={`anim-folder-${p.slug}`}
            className="gallery-item group text-left reveal"
            style={{ transitionDelay: `${(idx % 6) * 80}ms` }}
          >
            <div className="relative overflow-hidden bg-[var(--ink-2)]">
              <img
                src={p.cover}
                alt={p.title}
                loading="lazy"
                className="w-full h-[420px] object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[rgba(8,7,5,0.9)] via-transparent to-transparent" />
              {(p.filmLogo || (p.logos && p.logos.length > 0)) && (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 bg-[rgba(8,7,5,0.6)] opacity-0 group-hover:opacity-100 transition-opacity duration-500 px-6">
                  {p.filmLogo && (
                    <img
                      src={p.filmLogo}
                      alt={p.title}
                      className="h-16 md:h-20 max-w-[85%] object-contain"
                    />
                  )}
                  {p.logos && p.logos.length > 0 && (
                    <div className="flex items-center justify-center gap-8">
                      {p.logos.map((src) => (
                        <img
                          key={src}
                          src={src}
                          alt=""
                          className="h-6 md:h-8 max-w-[80px] object-contain"
                          style={{ filter: "brightness(0) invert(1)" }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="absolute bottom-5 left-5 right-5">
                <div className="font-serif text-2xl md:text-3xl text-[var(--paper)] leading-tight group-hover:text-[var(--ember)] transition-colors">{p.title}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.25em] text-[var(--bone)]">{p.studio}</div>
              </div>
            </div>
            <div className="mt-3 flex items-baseline justify-between">
              <div className="text-sm italic text-[var(--muted)]">{p.role}</div>
              <div className="text-xs font-mono text-[var(--gold)]">{p.year}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
